import "./new-tenant.scss";

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormTenant from "../form-tenant/form-tenant";
import { useNewTenant } from "./new-tenant.hook";

export function NewTenant() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewTenant();

  return (
    <div id="NewTenant" className="tenant">
      <HeaderContent
        title={<h1>New Tenant</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <FormTenant />
        </FormProvider>
      </div>
    </div>
  );
}

export default NewTenant;
